<template>
  <div v-show="is_aic_one_login">
    <div class="fab-container position-fixed  z-5" ref="fab_container" id="fabContainer" :style="{ left: fab_position.x + 'px', top: fab_position.y + 'px' }">
      <div class="fab-options position-absolute" :class="{ 'd-none': is_minimized }"  id="fabOptions" >
        <a
          v-for="(platform, index) in visible_platforms"
          :key="platform.name"
          :class="['fab-option', platform.class, 'rounded-circle', 'd-flex', 'align-items-center', 'justify-content-center']"
          :style="get_platform_position(index, visible_platforms.length)"
          :title="platform.title"
          @click="launch_platform(platform.name)"
        >
          <img
            :src="platform.icon"
            :alt="platform.title"
            :class="platform.iconClass"
          />
        </a>
      </div>


      <button class="fab-main cursor-pointer position-relative rounded-circle border-0 d-flex align-items-center justify-content-center"
        @click="handle_fab_click" @touchend="handle_fab_click" id="fabMain">
        <img
          v-if="!is_minimized" src="@/assets/images/aic_one/logos/aicone.svg"
          alt="Open Menu"
          class="fab-main-icon h-75"
        />
        <i v-else class="bi bi-arrows-angle-expand fab-expand-icon text-white"></i>
      </button>

    </div>
  </div>
</template>


<script>
const ALL_PLATFORMS = [
        {
          name: 'Proba_analytics',
          title: 'Proba Analytics',
          icon: require('@/assets/images/aic_one/logos/proba.png'),
          iconClass: 'fab-icon-small',
          class: 'fab-proba-analytics'
        },
        {
          name: 'Home',
          title: 'Home',
          icon: require('@/assets/images/aic_one/logos/aicone_logo_v3.svg'),
          iconClass: 'fab-icon-small h-75',
          class: 'fab-home'
        },
        {
          name: 'x-verdict',
          title: 'X-Verdict',
          icon: require('@/assets/images/aic_one/logos/xverdict.svg'),
          iconClass: 'fab-icon-small',
          class: 'fab-xverdict'
        },
        {
          name: 'Engagenet',
          title: 'Engagenet',
          icon: require('@/assets/images/aic_one/logos/engagenet.svg'),
          iconClass: 'fab-icon-small',
          class: 'fab-engagenet'
        },
        {
          name: 'Orcaa',
          title: 'Orcaa',
          icon: require('@/assets/images/aic_one/logos/orcaa.svg'),
          iconClass: 'fab-icon-wide',
          class: 'fab-orcaa'
        },
        {
          name: 'complyon',
          title: 'ComplyOn',
          icon: require('@/assets/images/aic_one/logos/complyon.svg'),
          iconClass: 'fab-icon-small',
          class: 'fab-complyon'
        },
        {
          name: 'proba',
          title: 'Proba Workflows',
          icon: require('@/assets/images/aic_one/logos/proba_white.svg'),
          iconClass: 'fab-icon-small',
          class: 'fab-proba-workflows'
        },
        {
          name: 'complyon_onboard',
          title: 'complyon onboard',
          icon: require('@/assets/images/aic_one/logos/complyon_onboard.png'),
          iconClass: 'fab-icon-small',
          class: 'fab-complyon'
        },
      ]

import { get_headers, LAUNCH_PLATFORM_URL } from "@/utils/system_constants/constant";
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from "axios";
import $ from 'jquery';


export default {
  name: "AiconeLogo",
   mixins: [alert_mixin],

  data() {
    return {
      fab_position: {
        x: 0,
        y: 0
      },
      is_dragging: false,
      dragOffset: {
        x: 0,
        y: 0
      },
      default_fab_position: {
        x: window.innerWidth - 110,
        y: 450
      },
      is_minimized: false,
      current_corner: null,
      corner_threshold: 50,
      headers: get_headers(),
      is_aic_one_login: false,
      current_platform: sessionStorage.getItem("current_platform") || "",
      all_platforms: ALL_PLATFORMS
    }
  },

  computed: {
    visible_platforms() {
      const visible_platforms = this.all_platforms.filter(platform => platform.name !== this.current_platform);
      return visible_platforms;
    }
  },

  mounted() {
    this.initialize_fab_position();
    this.setup_drag_listeners();
    // set reactive value once from sessionStorage
    this.is_aic_one_login = (sessionStorage.getItem("is_aic_one_login") || "").toLowerCase() === "true";

  },

  beforeUnmount() {
    this.remove_drag_listeners();
  },

  methods:{

    get_platform_position(index, total) {
      const radius = 60;
      const main_button_size = 56;
      const offset = main_button_size / 2 - 20;

      // Calculate angle for circular distribution
      const angle_step = (2 * Math.PI) / total;
      const start_angle = -Math.PI / 2; // Start from top
      const angle = start_angle + (angle_step * index);

      const x = Math.cos(angle) * radius + offset;
      const y = Math.sin(angle) * radius + offset;

      const pos = {
        left: `${x}px`,
        top: `${y}px`,
        transitionDelay: `${0.1 + index * 0.05}s`
      };

      return pos;
    },

    launch_platform(platform) {
      const external_user_id = sessionStorage.getItem("user_id");

      const data = {
        platform,
        external_user_id
      };

      axios.post(LAUNCH_PLATFORM_URL, data, {
         headers: this.headers
        })
        .then((response) => {
          const response_data = response.data;

          if (response_data.redirect_url) {
            window.location.href = response_data.redirect_url;
          } else {
            this.show_error('Failed to launch platform: No redirect URL provided');
          }
        })
        .catch((error) => {
          if (error.response) {
            switch (error.response.status) {
              case 403:
                this.show_error('Access denied to this platform');
                break;
              case 404:
                this.show_error('Platform not found or unavailable');
                break;
              default:
                this.show_error('Failed to launch platform');
            }
          } else {
            this.show_error('Network error: Could not connect to platform');
          }
        });
    },


    initialize_fab_position() {
      var position_key = "position_key";
      var saved_data = localStorage.getItem(position_key);
      var data;

      try {
        if (saved_data) {
           data = JSON.parse(saved_data);

          if (
            data.position &&
            typeof data.position.x === 'number' &&
            typeof data.position.y === 'number'
          ) {
            this.fab_position = data.position;
            this.current_corner = data.corner;
            this.is_minimized = data.is_minimized || false;
          } else {
            this.fab_position = { ...this.default_fab_position };
          }

          if (this.current_corner) {
            this.$nextTick(() => {
              var $fabContainer = $(this.$refs.fab_container);
              $fabContainer.addClass(`fab-corner ${this.current_corner} fab-minimized`);
            });
          }
        } else {
          this.fab_position = { ...this.default_fab_position };
        }
      } catch {
        this.fab_position = { ...this.default_fab_position };
      }
    },


    start_dragging(e) {
      if (!$(e.target).closest('#fabMain').length) return;

      this.is_dragging = true;
      var $fabContainer = $(this.$refs.fab_container);
      var rect = $fabContainer[0].getBoundingClientRect();


      if (e.type === 'mousedown') {
        this.dragOffset = {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        };
      } else if (e.type === 'touchstart') {
        this.dragOffset = {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top
        };
      }

      if (this.is_dragging) {
        $('.fab-option').css('pointer-events', 'none');
      }

      e.preventDefault();
    },

    during_dragging(e) {
      if (!this.is_dragging) return;

      let clientX, clientY;
      if (e.type === 'mousemove') {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.type === 'touchmove') {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      }

      var $fabContainer = $(this.$refs.fab_container);
      var fab_size = $fabContainer.width();
      var window_width = window.innerWidth;
      var window_height = window.innerHeight;

      var newX = Math.max(0, Math.min(window_width - fab_size, clientX - this.dragOffset.x));
      var newY = Math.max(0, Math.min(window_height - fab_size, clientY - this.dragOffset.y));

      var corner = this.check_corner_snap(clientX, clientY);

      if (corner) {
        this.if_corner(corner,$fabContainer,window_width,window_height, fab_size);
      }
      else {
        if (this.current_corner) {
          $fabContainer.removeClass(
            'fab-corner top-left top-right bottom-left bottom-right fab-minimized'
          );
          this.current_corner = null;
          this.is_minimized = false;
        }
        this.fab_position = { x: newX, y: newY };
      }
      e.preventDefault();
    },

    if_corner(corner, $fabContainer, window_width, window_height, fab_size) {

      this.current_corner = corner;
      $fabContainer
        .removeClass('top-left top-right bottom-left bottom-right')
        .addClass(`fab-corner ${corner} fab-minimized`);
      this.is_minimized = true;
      switch (corner) {
        case 'top-left':
          this.fab_position = { x: 0, y: 0 };
          break;
        case 'top-right':
          this.fab_position = { x: window_width - fab_size, y: 0 };
          break;
        case 'bottom-left':
          this.fab_position = { x: 0, y: window_height - fab_size };
          break;
        case 'bottom-right':
          this.fab_position = { x: window_width - fab_size, y: window_height - fab_size };
          break;
      }

    },

    stop_drag() {
      if (!this.is_dragging) return;
      this.is_dragging = false;
      $('.fab-option').css('pointer-events', 'auto');
      this.save_fab_position();
    },

    setup_drag_listeners() {

      var $fabMain = $('#fabMain');
      $fabMain.on('mousedown touchstart', this.start_dragging);

      $(window).on('mousemove touchmove', this.during_dragging);
      $(window).on('mouseup touchend', this.stop_drag);
      $(window).on('resize', this.handle_resize);
    },

    remove_drag_listeners() {
      $('#fabMain').off('mousedown touchstart', this.start_dragging);
      $(window).off('mousemove touchmove', this.during_dragging);
      $(window).off('mouseup touchend', this.stop_drag);
      $(window).off('resize', this.handle_resize);
    },

    handle_resize() {
      var fabSize = 56;
      var $window = $(window);
      this.fab_position.x = Math.max(0, Math.min($window.width() - fabSize, this.fab_position.x));
      this.fab_position.y = Math.max(0, Math.min($window.height() - fabSize, this.fab_position.y));

      localStorage.setItem("position_key", JSON.stringify(this.fab_position));
    },

    handle_fab_click() {
      if (this.is_minimized) {
        this.restore_fab();
      } else {
        this.toggle_fab_options();
      }
    },

    toggle_fab_options() {
      var fap_option = $('.fab-options');
      fap_option.toggleClass('show');
    },

    restore_fab() {
      this.is_minimized = false;
      this.current_corner = null;
      var $fabContainer = $(this.$refs.fab_container);
      $fabContainer.removeClass(
        'fab-corner top-left top-right bottom-left bottom-right fab-minimized'
      );

      var window_width = window.innerWidth;
      var window_height = window.innerHeight;
      var fab_size = $fabContainer.width();

      this.fab_position = {
        x: window_width - fab_size - 10,
        y: window_height - fab_size - 10
      };

      this.save_fab_position();
    },

    check_corner_snap(x, y) {
      var window_width = window.innerWidth;
      var window_height = window.innerHeight;
      var threshold = 0;
      var fab_size = $(this.$refs.fab_container).width();

      if (x <= threshold && y <= threshold) {
        return 'top-left';
      }
      if (x >= window_width - fab_size - threshold && y <= threshold) {
        return 'top-right';
      }
      if (x <= threshold && y >= window_height - fab_size - threshold) {
        return 'bottom-left';
      }
      if (x >= window_width - fab_size - threshold && y >= window_height - fab_size - threshold) {
        return 'bottom-right';
      }
      return null;
    },

    save_fab_position() {
      var position_data = {
        position: this.fab_position,
        corner: this.current_corner,
        is_minimized: this.is_minimized
      };

      localStorage.setItem("position_key", JSON.stringify(position_data));
    },


  },

}
</script>


<style scoped>

.fab-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 3.5rem;
  height: 3.5rem;
  z-index: 1000;
}

.fab-main {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: linear-gradient(90deg, black, #f00);
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px var(--color-red-shadow);
  z-index: 1001;
}

.fab-main:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 30px #f449;
}

.fab-options {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allow clicks to pass through to underlying elements when closed */
}

.fab-options.show {
  pointer-events: all; /* Re-enable clicks when menu is open */
}

.fab-option {
  position: absolute;
  width: 40px;
  height: 40px;
  backdrop-filter: blur(10px);
  border: 1px solid var(--color-white-transparent-2);
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0);
}

.fab-options.show .fab-option {
  opacity: 1;
  transform: scale(1);
}

.draggable {
  position: fixed !important;
  user-select: none;
  touch-action: none;
  cursor: move;
}

/* FAB individual colors */
.fab-proba-analytics {
  background: var(--color-proba-analytics);
  border-color: var(--color-proba-analytics-border);
}

.fab-proba-analytics:hover {
  background: var(--color-proba-analytics-border);
  box-shadow: 0 4px 15px var(--color-proba-analytics-border);
  transform: scale(1.1);
}

.fab-home {
  background: var(--color-aic-one);
  border-color: var(--color-aic-one-border);
}

.fab-home:hover {
  background: var(--color-aic-one-border);
  box-shadow: 0 4px 15px var(--color-aic-one-border);
  transform: scale(1.1);
}

.fab-xverdict {
  background: var(--color-x-verdict);
  border-color: var(--color-x-verdict-border);
}

.fab-xverdict:hover {
  background: var(--color-x-verdict-border);
  box-shadow: 0 4px 15px var(--color-x-verdict-border);
  transform: scale(1.1);
}

.fab-engagenet {
  background: var(--color-engagenet);
  border-color: var(--color-engagenet-border);
}

.fab-engagenet:hover {
  background: var(--color-engagenet-border);
  box-shadow: 0 4px 15px var(--color-engagenet-border);
  transform: scale(1.1);
}

.fab-orcaa {
  background: var(--color-orcaa);
  border-color: var(--color-orcaa-border);
}

.fab-orcaa:hover {
  background: var(--color-orcaa-border);
  box-shadow: 0 4px 15px var(--color-orcaa-border);
  transform: scale(1.1);
}

.fab-complyon {
  background: var(--color-complyon);
  border-color: var(--color-complyon-border);
}

.fab-complyon:hover {
  background: var(--color-complyon-border);
  box-shadow: 0 4px 15px var(--color-complyon-border);
  transform: scale(1.1);
}

.fab-proba-workflows {
  background: var(--color-proba-workflows);
  border-color: var(--color-proba-workflows-border);
}

.fab-proba-workflows:hover {
  background: var(--color-proba-workflows-border);
  box-shadow: 0 4px 15px var(--color-proba-workflows-border);
  transform: scale(1.1);
}

.fab-corner {
  position: fixed !important;
  transition: all 0.3s ease;
  margin: 0 !important;
}

.fab-corner.top-left {
  top: 0 !important;
  left: 0 !important;
  transform: scale(0.8);
}

.fab-corner.top-right {
  top: 0 !important;
  right: 0 !important;
  left: auto !important;
  transform: scale(0.8);
}

.fab-corner.bottom-left {
  bottom: 0 !important;
  left: 0 !important;
  top: auto !important;
  transform: scale(0.8);
}

.fab-corner.bottom-right {
  inset: auto 0 0 auto !important;
  transform: scale(0.8);
}

.fab-minimized {
  transform: scale(0.8);
}

</style>
